export default __webpack_public_path__ + "static/food-cutting-8c5d346ee6ebac8477510162636df287.svg";